import { ErrorOutline, MoreVert } from '@mui/icons-material';
import { IconButton, ListItem } from '@mui/material';
import {
  ExtendedList,
  ExtendedListItemText,
  ExtendedListProps,
  Widget,
  WidgetContent,
  WidgetHeader,
  WidgetIcon,
  ExtendedListItemButton,
  useScrollIntoView,
} from '@procureai/ui-mui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

const WIDGET_NAME = 'SupplierRiskAlertWidget';
type ItemData = {
  title: string;
  subTitle?: string;
  color: 'error' | 'warning' | 'info' | 'success' | 'primary' | 'secondary' | 'inherit' | undefined;
};
export const SupplierRiskAlertWidget = () => {
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: WIDGET_NAME });
  const [widgetRef, active] = useScrollIntoView({ hash: 'risk-supplier-alert' });
  const items: ItemData[] = [
    {
      title: '5 Suppliers with high risk score',
      subTitle: 'Request additional information from the suppliers',
      color: 'error',
    },
    {
      title: '50 Suppliers with medium risk score',
      color: 'warning',
    },
  ];
  const renderItem: NonNullable<ExtendedListProps<ItemData>['renderItem']> = useMemo(
    () =>
      ({ item }) => {
        const { title, color, subTitle } = item;
        t('');
        return (
          <ListItem disablePadding>
            <ExtendedListItemButton color={color}>
              <ExtendedListItemText primary={title} secondary={subTitle} />
              <IconButton
                color="inherit"
                aria-label="more"
                size="small"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={() => {}}
              >
                <MoreVert />
              </IconButton>
            </ExtendedListItemButton>
          </ListItem>
        );
      },
    [t],
  );
  return (
    <Widget ref={widgetRef} active={active} data-intercom-target="ContractAlertsWidget">
      <WidgetHeader title={t('title')} icon={<WidgetIcon color="error" icon={<ErrorOutline fontSize="small" />} />} />
      <WidgetContent>
        <ExtendedList items={items} renderItem={renderItem} />
      </WidgetContent>
    </Widget>
  );
};
